import WidgetUtility from '../shared/widget-utility';

class ProductsByCategory {
    constructor(container) {
        if (typeof (container) === 'string') {
            this.selector = container;
        }
        else if (container instanceof NodeList) {
            this.containers = Array.from(container);
        }
        else {
            this.container = [container];
        }
    }

    init() {
        if (this.selector) {
            this.containers = Array.from(document.querySelectorAll(this.selector));
        }
        this.containers.forEach(container => {
            var groups = container.querySelectorAll('.category-group');
            Array.from(groups).forEach(group => {
                var group = new CategoryGroup(group);
                group.init();
            })
        })
    }
}

class CategoryGroup {
    constructor(element) {
        this.element = typeof (element) === 'string' ? document.querySelector(element) : element;

    }

    init() {
        this.controls = this.element.querySelector('.controls');
        this.tabs = Array.from(this.element.querySelectorAll('.underline-link'));
        this.summaries = Array.from(this.element.querySelectorAll('.summary'));
        this.backgrounds = Array.from(this.element.querySelectorAll('.background > img'));
        this.carouselContainers = Array.from(this.element.querySelectorAll('.products-container'));
        this.carousels = Array.from(this.element.querySelectorAll('.products > ul'));
        this.index = 0;
        this._items = Array.from(this.carousels[this.index].querySelectorAll('li'));
        this.tabs.forEach(tab => {
            tab.addEventListener('click', this.switchCategory.bind(this));
        });
        this.prevButton = this.element.querySelector('.circle-button--previous');
        this.prevButton.addEventListener('click', this._shiftLeft.bind(this));
        this.nextButton = this.element.querySelector('.circle-button--next');
        this.nextButton.addEventListener('click', this._shiftRight.bind(this));
        window.addEventListener('DOMContentLoaded', () => {
            this._findViewpointIndexes();
            this._updateNavigationVisibility();
            if (!this.nextButton.classList.contains('disabled')) {
                this.controls.style.display = 'inherit';
            }
        });
        window.addEventListener('resize', this._handleResize.bind(this));
    }
    _handleResize() {
        this._findViewpointIndexes();
        this._updateNavigationVisibility();
    }

    switchCategory(event) {
        if (!this._locked) {
            this._locked = true;
            var parent = event.target.parentNode;
            var index = Array.from(parent.parentNode.children).indexOf(parent);
            var activeItems = this._getAnimationElements(this.index);
            var targetItems = this._getAnimationElements(index);
            activeItems.tab.classList.remove('active');
            targetItems.tab.classList.add('active');
            var tl = new TimelineLite({
                onComplete: function () {
                    this._locked = false;
                    activeItems.background.classList.remove('active');
                    activeItems.itemsContainer.classList.remove('active');
                    activeItems.summary.classList.remove('active');
                    targetItems.background.classList.add('active');
                    targetItems.itemsContainer.classList.add('active');
                    targetItems.summary.classList.add('active');
                    gsap.set([activeItems.background, activeItems.summary, activeItems.carousel, activeItems.button], { clearProps: 'all' });
                    if (activeItems.items.length) {
                        gsap.set([activeItems.background, activeItems.summary, activeItems.carousel, activeItems.button, activeItems.items], { clearProps: 'all' });
                    }
                    gsap.set([targetItems.background, targetItems.summary, targetItems.label, targetItems.visibleItems, targetItems.button, this.prevButton, this.nextButton], { clearProps: 'all' });
                    if (targetItems.items.length) {
                        gsap.set([targetItems.background, targetItems.summary, targetItems.carousel, targetItems.button], { clearProps: 'all' });
                    }
                    this._items = targetItems.items;
                    this._findViewpointIndexes();
                    this._updateNavigationVisibility();
                }.bind(this)
            })
                .set(targetItems.background, { display: 'inherit' })
                .addLabel('start')
                .to([this.prevButton, this.nextButton], { autoAlpha: 0, duration: .4 })
                .fromTo(activeItems.background, { zIndex: 2, autoAlpha: 1, x: 0 }, { autoAlpha: 0, x: 200, duration: 1 }, 'start')
                .to(activeItems.summary, { x: 100, autoAlpha: 0, duration: .5 }, '-=.8')
                .to(activeItems.label, { x: 100, autoAlpha: 0, duration: .5 }, '-=.4')
                .set(targetItems.itemsContainer, { display: 'inherit' })
                .set(targetItems.summary, { display: 'inherit' })
                .addLabel('summary')
            if (activeItems.visibleItems.length) {
                tl.staggerTo(activeItems.visibleItems, .3, { x: 100, autoAlpha: 0 }, .05, '-=.4')
            }
            tl
                .fromTo(activeItems.button, { x: 0, autoAlpha: 1 }, { x: 64, autoAlpha: 0, duration: .3 }, '-=.1')
                .fromTo(targetItems.summary, { x: -100, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: .5 }, 'summary')
                .fromTo(targetItems.label, { x: -100, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: .5 }, '-=.4')
                .staggerFrom(targetItems.visibleItems, .3, { x: -50, autoAlpha: 0 }, .05, '-=.4')
                .addLabel('carouselReady')
                .set(this.controls, { display: targetItems.showControls ? 'block' : 'none' });
            if (targetItems.showControls) {
                tl.to([this.prevButton, this.nextButton], { autoAlpha: 1, duration: .4 });
            }
                tl.fromTo(targetItems.button, { x: -64, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: .2 }, 'carouselReady-=.2');
            this.index = index;
        }
    }

    _getAnimationElements(index) {
        var carouselContainer = this.carouselContainers[index];
        carouselContainer.style.display = 'inherit';
        var allItems = Array.from(carouselContainer.querySelectorAll('li'));
        var docWidth = document.documentElement.clientWidth;
        var items = Array.from(allItems).filter(node => {
            var rect = node.getBoundingClientRect();
            return rect.left > -rect.width && rect.right < docWidth + rect.width;
        });
        carouselContainer.style.display = '';
        return {
            showControls: allItems.length !== items.length,
            tab: this.tabs[index],
            background: this.backgrounds[index],
            label: carouselContainer.querySelector('h5'),
            carousel: this.carousels[index],
            items: allItems,
            visibleItems: items,
            itemsContainer: carouselContainer,
            summary: this.summaries[index],
            button: carouselContainer.querySelector('.button-container')
        }
    }

    _shiftLeft() {
        this._shift(1);
    }

    _shiftRight() {
        this._shift(-1);
    }

    _shift(direction) {
        if (!this._locked) {
            this._locked = true;
            var currentCarousel = this.carouselContainers[this.index].querySelector('.products');
            var containerEdge = currentCarousel.getBoundingClientRect().left;
            var list = this.carousels[this.index];
            var leftShiftMax = currentCarousel.clientWidth - this._items[this._items.length - 1].getBoundingClientRect().right;
            var shift, oldShift;
            shift = oldShift = list._gsap ? parseInt(list._gsap.x) : 0;
            if (direction === 1) {
                var left = document.documentElement.clientWidth - this._items[this.leftEdge].getBoundingClientRect().right;
                var offset = left;
                for (var i = this.leftEdge - 1; i >= 0; i--) {
                    var newOffset = containerEdge - this._items[i].getBoundingClientRect().left;
                    if (newOffset <= left) {
                        offset = newOffset;
                    }
                    else {
                        break;
                    }
                }
                shift = Math.min(0, shift + offset);
            }
            else {
                var right = containerEdge - this._items[this.rightEdge].getBoundingClientRect().left;
                shift += Math.max(right, leftShiftMax);
            }
            if (shift === 0) {
                this.prevButton.classList.add('disabled');
            }
            else {
                this.prevButton.classList.remove('disabled');
            }
            if (oldShift + leftShiftMax === shift) {

                this.nextButton.classList.add('disabled');
            }
            else {
                this.nextButton.classList.remove('disabled');
            }
            TweenLite.to(list, .5, {
                x: shift,
                onComplete: function () {
                    this._locked = false;
                    this._findViewpointIndexes();
                }.bind(this)
            });
        }
    }


    _findViewpointIndexes() {
        var found = false;
        var lastFound = false;
        var docWidth = document.documentElement.clientWidth;
        for (var i = 0; i < this._items.length; i++) {
            var rect = this._items[i].getBoundingClientRect();
            if (rect.left >= 0 && rect.right <= docWidth) {
                if (!found) {
                    this.leftEdge = Math.max(i - 1, 0);
                    found = true;
                }
            }
            else if (found) {
                this.rightEdge = i;
                lastFound = true;
                break;
            }

        }
        if (!lastFound) {
            this.rightEdge = this._items.length - 1;
        }
    }

    _updateNavigationVisibility() {
        if (this.leftEdge === 0) {
            this.prevButton.classList.add('disabled');
        }
        else {
            this.prevButton.classList.remove('disabled');
        }
        if (this.rightEdge === this._items.length - 1) {
            this.nextButton.classList.add('disabled');
        }
        else {
            this.nextButton.classList.remove('disabled');
        }
    }
}

export { ProductsByCategory as default, CategoryGroup };